import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Lock, Loader2, Ship } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/login`, {
        password: password
      });

      if (response.data.success) {
        login(response.data.token);
        toast.success('Login successful');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      toast.error('Invalid password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#003d5c] via-[#004d70] to-[#002a40] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-gradient-to-br from-[#003d5c] to-[#005580] rounded-full flex items-center justify-center mx-auto mb-4">
            <Ship className="h-10 w-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-[#003d5c]">Admin Dashboard</h1>
          <p className="text-gray-600 mt-2">COZEY YILDIZ EXPORT L.L.C</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <Label htmlFor="password" className="text-[#003d5c] font-semibold">Admin Password</Label>
            <div className="relative mt-2">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="pl-11 h-12 text-lg"
                required
                data-testid="admin-password-input"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading || !password}
            className="w-full h-12 bg-[#003d5c] hover:bg-[#002a40] text-white text-lg font-semibold"
            data-testid="admin-login-button"
          >
            {loading ? (
              <>
                <Loader2 className="h-5 w-5 animate-spin mr-2" />
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </Button>
        </form>

        <p className="text-center text-sm text-gray-500 mt-6">
          Restricted area. Authorized personnel only.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
